var PartnerServiceSearchJs = (function ($) {

    var addClickHandlerAnchorButton = function (anchorSel, containerSel) {
        $(anchorSel).on("click", function() {
            $(containerSel).show("fast", function() {
                $('html, body').animate({scrollTop: $(containerSel).offset().top});
            });
        });
    };

    var setUpImageGalleryActions = function () {
        $("a.j-image-gallery").fancybox({
            hideOnContentClick: false,
            helpers : {
                overlay : {
                    locked : false
                }
            }
        });

        $('.cloudzoom, .cloudzoom-gallery').CloudZoom({'galleryFade ': 0});

        $(".j-gallery-image-item").on("click", function() {
            updateImageGallery($(this));
        });
    };

    var updateImageGallery = function ($obj) {
        if ($obj.attr("data-medium")) {
            var mainImage = $(".j-gallery-main-image");
            mainImage.attr("src", $obj.attr("data-medium"));
            mainImage.parent().attr("href", $obj.attr("data-enlarged"));

            var cloudZoomImageInstance = mainImage.data("CloudZoom");
            var smallImage = $obj.attr("data-medium");
            var largeImage = $obj.attr("data-enlarged");
            cloudZoomImageInstance.loadImage(smallImage, largeImage);
        }
    };

    var setupQuickOrderAction = function (btnSel) {
        $(btnSel).on('click', function () {
            var $this = $(this);
            var callData = {};
            callData.productCode = $this.attr('attr-productCode');
            callData.productFmtPrice = $this.attr('attr-productFmtPrice');
            callData.inStock = $this.attr('attr-inStock');
            callData.productShortDescription = $this.attr('attr-productShortDescription');
            MainJS.ajaxCall($this.attr("attr-href"), "GET", callData, function(data) {
                var $data = $(data);
                $.fancybox({
                    width: 500,
                    height: 'auto',
                    fitToView : true,
                    autoSize : false,
                    content : $data,
//                    wrapCSS : $(eSel).data('wrapCss'),
                    helpers : {
                        overlay : {
                            locked : false
                        }
                    }
                });
            }, null, {});
        });
    };


    return {
        addClickHandlerAnchorButton: addClickHandlerAnchorButton,
        setUpImageGalleryActions: setUpImageGalleryActions,
        updateImageGallery: updateImageGallery,
        setupQuickOrderAction: setupQuickOrderAction
    }
}) (jQuery);

$(document).ready(function() {
    if ($(".productDetailesPage").length || $(".productDetailComponent").length) {
        PartnerServiceSearchJs.addClickHandlerAnchorButton(".j-partner-search-service-action", ".service-partner-block");
        PartnerServiceSearchJs.setUpImageGalleryActions();
        PartnerServiceSearchJs.updateImageGallery($('.j-gallery-image-list > span:first'));
        PartnerServiceSearchJs.setupQuickOrderAction(".j-quickOrderBtn");
    }
});
